module.exports = __webpack_public_path__ + "img/coach_lock_grey.0cc6d0ec.svg";